import React from "react";

export interface AppContextProps {
    readonly swipeType: "Base"|"DomTom";
}

export const AppContext = React.createContext<AppContextProps>({
    swipeType: "Base"
});